import { createEvent } from 'effector';

import { AlertState } from './AlertState';

export const alertEvent = createEvent<Partial<AlertState>>('alertEvent');
